import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/translation/(tabs)/tasks-in-progress/page.tsx")